enum DocumentClass {
    Code = "DocClass",

    Summary = "DocClass1",
    ClinicalNote = "DocClass2",
    ConsultationReports = "DocClass3",
    Results = "DocClass4",
    Forms = "DocClass5",
    MedicationAndPrescriptions = "DocClass6",
    Requests = "DocClass7",
    Other = "DocClass8",
    ScannedPaperRecord = "DocClass9"
}

enum DocumentSubClassSummary {
    Code = "DocSubClassSummary",

    MedicalSummary = "DocSubClassSummary1",
    ProblemsAndDiagnoses = "DocSubClassSummary2",
    DischargeSummary = "DocSubClassSummary3",
    RecordSummaryRequest = "DocSubClassSummary4",
    PreviousRecord = "DocSubClassSummary5",
    Pharmacy = "DocSubClassSummary6",
    Other = "DocSubClassSummary7"
}

enum DocumentSubClassClinicalNote {
    Code = "DocSubClassCliNote",

    FamilyDoctor = "DocSubClassCliNote1",
    Specialist = "DocSubClassCliNote2",
    Nursing = "DocSubClassCliNote3",
    ThematicClinics = "DocSubClassCliNote4",
    HealthProfessionals = "DocSubClassCliNote5",
    OccupationalHealthAndSafety = "DocSubClassCliNote6",
    Other = "DocSubClassCliNote7"
}

enum DocumentSubClassConsultationReports {
    Code = "DocSubClassConsReports",

    FamilyDoctor = "DocSubClassMedReports1",
    Specialist = "DocSubClassMedReports2",
    Nursing = "DocSubClassMedReports3",
    ThematicClinics = "DocSubClassMedReports4",
    HealthProfessionals = "DocSubClassMedReports5",
    OccupationalHealthAndSafety = "DocSubClassMedReports6",
    Other = "DocSubClassMedReports7"
}

enum DocumentSubClassResults {
    Code = "DocSubClassResults",

    Laboratory = "DocSubClassResults1",
    Imaging = "DocSubClassResults2",
    Endoscopy = "DocSubClassResults3",
    Cardiology = "DocSubClassResults4",
    SpecialTests = "DocSubClassResults5",
    Other = "DocSubClassResults6"
}

enum DocumentSubClassForms {
    Code = "DocSubClassForms",

    MedicalCertificate = "DocSubClassForms1",
    MedicalEvaluation = "DocSubClassForms2",
    Consent = "DocSubClassForms3",
    RAMQ = "DocSubClassForms4",
    CSST = "DocSubClassForms5",
    SAAQ = "DocSubClassForms6",
    Insurance = "DocSubClassForms7",
    Other = "DocSubClassForms8"
}

enum DocumentSubClassMedications {
    Code = "DocSubClassMeds",

    ExceptionalMedicationsRequest = "DocSubClassMeds1",
    PrescriptionForm = "DocSubClassMeds2",
    NonpharmacologicalPrescription = "DocSubClassMeds3",
    Prescription = "DocSubClassMeds4",
    PharmacologicalProfile = "DocSubClassMeds5",
    Other = "DocSubClassMeds6"
}

enum DocumentSubClassRequests {
    Code = "DocSubClassRequests",

    LaboratoryRequests = "DocSubClassRequests1",
    ImagingRequests = "DocSubClassRequests2",
    ExternalRequests = "DocSubClassRequests3",
    ConsultationRequests = "DocSubClassRequests4",
    HospitalServicesRequests = "DocSubClassRequests5",
    Other = "DocSubClassRequests6"
}

enum DocumentSubClassOther {
    Code = "DocSubClassOther",

    TherapeuticIntensity = "DocSubClassOther1",
    ClinicalToolsAndMonitoring = "DocSubClassOther2",
    Questionnaires = "DocSubClassOther3",
    PatientServices = "DocSubClassOther4",
    TravelHealth = "DocSubClassOther5",
    Other = "DocSubClassOther6"
}

enum DocumentSubClassScannedPaperRecord {
    Code = "DocSubClassPaperRecord",

    Complete = "DocSubClassPaperRecord1",
    ClinicalNotes = "DocSubClassPaperRecord2",
    LaboratoryResults = "DocSubClassPaperRecord3",
    ImagingResults = "DocSubClassPaperRecord4",
    ConsultationReports = "DocSubClassPaperRecord5",
    MedicationAndPrescriptions = "DocSubClassPaperRecord6",
    Requests = "DocSubClassPaperRecord7",
    Other = "DocSubClassPaperRecord8"
}

export {
    DocumentClass,
    DocumentSubClassClinicalNote,
    DocumentSubClassConsultationReports,
    DocumentSubClassForms,
    DocumentSubClassMedications,
    DocumentSubClassOther,
    DocumentSubClassRequests,
    DocumentSubClassResults,
    DocumentSubClassScannedPaperRecord,
    DocumentSubClassSummary
};
